import ChevronRightIcon from "@atlaskit/icon/core/chevron-right";
import DownloadIcon from "@atlaskit/icon/core/download";
import {AnankeDropdownItem} from "@vesta/ananke/components/anankeDropdownItem";
import {AnankeDropdownItemGroup} from "@vesta/ananke/components/anankeDropdownItemGroup";
import {AnankeDropdownMenu} from "@vesta/ananke/components/anankeDropdownMenu";

type ExportNestedDropdownItemProps = {
    onExportCsv?: () => void;
    /** Omit to hide PDF (journeys/events list routes). */
    onExportPdf?: () => void;
    onExportPng?: () => void;
};

/**
 * Nested Atlaskit submenu: "Export" row opens CSV / PDF (and optional PNG) to the right.
 */
export function ExportNestedDropdownItem({
    onExportCsv,
    onExportPdf,
    onExportPng,
}: ExportNestedDropdownItemProps) {
    const exportIcon = <DownloadIcon label="" />;
    const chevron = <ChevronRightIcon label="" size="small" />;

    return (
        <AnankeDropdownMenu<HTMLDivElement>
            placement="right-start"
            shouldRenderToParent={true}
            trigger={({triggerRef, ...triggerProps}) => (
                <AnankeDropdownItem
                    {...triggerProps}
                    ref={triggerRef}
                    aria-haspopup={true}
                    elemBefore={exportIcon}
                    elemAfter={chevron}
                >
                    Export
                </AnankeDropdownItem>
            )}
        >
            <AnankeDropdownItemGroup>
                {onExportPng !== undefined ? (
                    <AnankeDropdownItem onClick={onExportPng} elemBefore={exportIcon}>
                        Export as PNG
                    </AnankeDropdownItem>
                ) : null}
                {onExportCsv !== undefined ? <AnankeDropdownItem
                    onClick={onExportCsv}
                    elemBefore={exportIcon}
                >
                    Export as CSV
                </AnankeDropdownItem> : null}
                {onExportPdf !== undefined ? (
                    <AnankeDropdownItem onClick={onExportPdf} elemBefore={exportIcon}>
                        Export as PDF
                    </AnankeDropdownItem>
                ) : null}
            </AnankeDropdownItemGroup>
        </AnankeDropdownMenu>
    );
}
